export default __webpack_public_path__ + "static/media/sv44_kr_jing_b3.1fdf6d14.mp3";